import React from 'react'
import intl from 'react-intl-universal'

export default function AreaLabel({ areaType, area = '', onlyNeedAreaType = false }) {
    if (!areaType) return;
    let txt = ''
    switch (areaType) {
        case 1:
            txt = intl.get('order_room_no').d('房号');
            break
        case 2:
            txt = intl.get('order_table_no').d('台号');
            break
        case 3:
            txt = intl.get('equity_outside').d('外部');
            break
        case 4:
            txt = intl.get('aaa').d('Pool bar');
            break
        case 5:
            txt = intl.get('aaa').d('Tour');
            break
        case 6:
            txt = intl.get('hotel_public').d('Public');
            break
    }

    if (onlyNeedAreaType) return txt

    return (
        <small>{txt}&nbsp;{area}</small>
    )
}
